export default __webpack_public_path__ + "c6b8534c071429e76ad768eb2a291fd0.png";